// reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as MerchantActions from '../action/auth.actions';
import { MerchantDetails, Person } from '../model/auth.model';

export interface MerchantState {
  merchant: MerchantDetails | null;
  reserveFund: boolean | null;
  merchantKeyValidation: number | null;
  QRlink: any | null;
  paymentLink: any | null;
  latestMerchantSalesContact: Person | null;
  esignProcessStatus: any | null;
  permissions: any[] | null;
  transactionDetailsCount: any | null;
  error: any;
}

export const initialState: MerchantState = {
  merchant: null,
  reserveFund: null,
  merchantKeyValidation: null,
  latestMerchantSalesContact: null,
  paymentLink:  null,
  QRlink: null,
  permissions: null,
  esignProcessStatus: null,
  transactionDetailsCount: null,
  error: null,
};

export const merchantReducer = createReducer(
  initialState,
  on(MerchantActions.resetMerchantState, () => initialState),
  on(MerchantActions.loadMerchantDetailsSuccess, (state, { merchant }) => ({
    ...state,
    merchant,
    error: null,
  })),
  on(MerchantActions.loadMerchantDetailsFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(MerchantActions.loadReserveFundSuccess, (state, { reserveFund }) => ({
    ...state,
    reserveFund,
    error: null,
  })),
  on(MerchantActions.loadReserveFundFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(MerchantActions.checkMerchantKeyIdSuccess, (state, { success }) => ({
    ...state,
    merchantKeyValidation: success,
    error: null,
  })),
  on(MerchantActions.checkMerchantKeyIdFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(MerchantActions.getQRCodeSuccess, (state, { QRlink }) => ({
    ...state,
    QRlink,
    error: null,
  })),
  on(MerchantActions.getQRCodeFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(MerchantActions.getUserPermissionsSuccess, (state, { permissions }) => ({
    ...state,
    permissions,
    error: null,
  })),
  on(MerchantActions.getUserPermissionsFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(MerchantActions.loadTransactionDetailsCountSuccess, (state, { response }) => ({
    ...state,
    transactionDetailsCount: response,
    error: null,
  })),
  on(MerchantActions.loadTransactionDetailsCountFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(MerchantActions.loadEsignProcessStatusSuccess, (state, { response }) => ({
    ...state,
    esignProcessStatus: response,
    error: null,
  })),
  on(MerchantActions.loadEsignProcessStatusFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(MerchantActions.loadPaymentLinkSuccess, (state, { response }) => ({
    ...state,
    paymentLink: response.QuickCode,
    error: null,
  })),
  on(MerchantActions.loadPaymentLinkFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(MerchantActions.loadLatestMerchantSalesContactSuccess, (state, { response }) => ({
    ...state,
    latestMerchantSalesContact: response[0],
    error: null,
  })),
  on(MerchantActions.loadLatestMerchantSalesContactFailure, (state, { error }) => ({
    ...state,
    error,
  })),

);
